<template>
  <div style="background-color:#fff;">
    <div class="fixed-toolbox">
      <div>
        <a-checkbox :defaultChecked="initIntro" @change="toggleIntro">简介</a-checkbox>
      </div>
      <div>
        <a-checkbox :defaultChecked="initVideo" @change="toggleVideo">视频</a-checkbox>
      </div>
    </div>
    <div class="flex-container min-h-46px mb-4px items-center">
      <div
        v-for="(process, index) in processList"
        :key="process.id"
        style="display: flex;align-items: center;font-size: 1.05em;"
      >
        <a-divider v-if="index != 0" type="vertical" />
        <div class="flex-item" @click="switchProcess(process.id)" :class="{ 'b-active': process.id === activeKey }">
          {{ process.processName }}
        </div>
      </div>
    </div>

    <a-row :gutter="16" type="flex">
      <a-col :md="showVideo && videoList.length > 0 ? 16 : 24" :sm="24">
        <a-collapse default-active-key="1" v-model="introKey">
          <a-collapse-panel header="简介" key="1" v-if="initIntro">
            <a-row :gutter="16" :style="{ 'min-height': '200px' }">
              <a-col :span="12">
                <a-card :bodyStyle="{ 'min-height': '200px' }" size="small">
                  <img :src="process.pictureObjId ? getImgView(process.pictureObjId) : processDefaulPng" slot="cover" />
                </a-card>
              </a-col>
              <a-col :span="12">
                <a-card
                  :bodyStyle="{ 'min-height': '265px' }"
                  :bordered="false"
                  :headStyle="{ 'text-align': 'center' }"
                  size="small"
                  title="工艺简介"
                >
                  <a-button @click="to3Dpage(process.id)" slot="extra" style="margin-left: 20px" type="link"
                    >三维</a-button
                  >
                  <p>{{ process.description }}</p>
                </a-card>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>

        <a-card size="small" title="重点指标" v-if="!!Object.keys(displayGroups).length">
          <span slot="extra">
            选择时间：
            <j-quick-time-range :style="{ width: '180px' }" @change="setFastRange" v-model="fastTimeRange" />
          </span>

          <a-row :gutter="16">
            <a-col
              :key="groupName"
              :span="24 / Object.keys(displayGroups).length"
              v-for="(group, groupName) in displayGroups"
            >
              <a-card :bordered="false" :headStyle="{ 'text-align': 'center' }" :title="groupName" size="small">
                <v-chart
                  :option="groupLineOpts[groupName]"
                  ref="echart"
                  style="width: 100%; height: 200px; background-color: #fff"
                />
              </a-card>
            </a-col>
          </a-row>
        </a-card>

        <a-card size="small" title="关注指标">
          <span slot="extra">
            每行个数:
            <a-select
              :style="{ width: '120px', 'margin-right': '20px' }"
              @change="changeRowChartCnt"
              v-model="rowChartCount"
            >
              <a-select-option value="2">2</a-select-option>
              <a-select-option value="3">3</a-select-option>
              <a-select-option value="4">4</a-select-option>
            </a-select>
          </span>
          <span slot="extra" v-if="!Object.keys(displayGroups).length">
            选择时间：
            <j-quick-time-range :style="{ width: '180px' }" @change="setFastRange" v-model="fastTimeRange" />
          </span>
          <a-button @click="toOtherPage('/monitor/dataLine')" slot="extra" style="margin-left: 20px" type="link"
            >更多</a-button
          >

          <a-row :gutter="16">
            <a-col :key="'point-data-' + point.pointCode" :span="24 / rowChartCount" v-for="point of pointsList">
              <a-card :bordered="false" :title="point.pointName" size="small">
                <v-chart
                  :option="pointsLineOpts[point.pointCode]"
                  ref="echart"
                  style="width: 100%; height: 200px; background-color: #fff"
                />
              </a-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :md="8" :sm="24" v-show="showVideo && videoList.length > 0">
        <a-card :headStyle="{ 'text-align': 'center' }" size="small" title="视频监控">
          <a-button @click="toOtherPage('/video/ys-live')" slot="extra" style="margin-left: 20px" type="link"
            >更多</a-button
          >
          <a-card
            :bodyStyle="{ 'min-height': '100px', height: `${(windowWidth * 0.3 * 9) / 16}px` }"
            :bordered="false"
            :headStyle="{ 'text-align': 'center' }"
            :key="video.id"
            :title="video.videoName"
            size="small"
            v-for="video in videoList"
          >
            <iframe
              :src="video.liveUrl"
              allow="autoplay"
              allowfullscreen
              frameborder="0"
              style="width:100%;height:100%;"
            ></iframe>
          </a-card>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import ACol from 'ant-design-vue/es/grid/Col'
import { getAction, getFileAccessHttpUrl } from '@/api/manage'
import moment from 'dayjs'
import { use } from 'echarts/core'
import { LegendComponent, TitleComponent, ToolboxComponent } from 'echarts/components'
import { LineChart } from 'echarts/charts'
import VChart from 'vue-echarts'
import processDefaulPng from '@/assets/process.jpg'
// import player from '../video/modules/jessibuca.vue'
import player from '../video/modules/player.vue'
import { getIframesByUrl, getIframesMenuPathBykeyWord } from '@/utils/util'
import { setStore, getStore, clearStore } from '@/utils/storage'

use([LineChart, LegendComponent, TitleComponent, ToolboxComponent])

export default {
  name: 'ProcessGeneral',
  components: {
    ACol,
    VChart,
    player
  },
  data() {
    return {
      initIntro: false,
      initVideo: false,
      windowWidth: window.innerWidth,
      introKey: '1',
      processDefaulPng: processDefaulPng,
      showVideo: false,
      videoSrc: '',
      activeKey: '',
      process: {},
      defaultActiveKey: '',
      processList: [],
      updateLooper: 0, //数据刷新轮训标志
      videoList: [],
      timeRange: [
        moment()
          .add(-1, 'days')
          .format('YYYY-MM-DD HH:mm:ss'),
        moment().format('YYYY-MM-DD HH:mm:ss')
      ],
      fastTimeRange: 'Last 24 hours',

      displayGroups: {},
      groupLineOpts: {},

      pointsList: [],
      pointsLineOpts: {},
      rowChartCount: '3',
      url: {
        getProcesslist: '/device/devProcess/list',
        getProceePoints: '/monitor/iotModelPoints/list',
        getPointsGrouplist: '/monitor/iotModelPointsGroup/list',
        getPointData: '/monitor/data/pointdata',
        getVideoList: '/video/videoDevice/list',
        getModelData: '/model/modelData/modelData',
        getWebViewPanel: '/monitor/iotModelPoints/getWebViewPanel'
      }
    }
  },
  created() {
    this.getProcess()

    this.initIntro = !!getStore('procee_initIntro')
    this.initVideo = !!getStore('procee_initVideo')

    if (this.initVideo) {
      this.showVideo = true
      this.loadVideos()
    }
  },
  destroyed() {
    clearTimeout(this.updateLooper)
  },

  methods: {
    toggleIntro(event) {
      this.introKey = event.target.checked ? '1' : '0'
      setStore('procee_initIntro', this.introKey)
      this.initIntro = event.target.checked
    },
    toggleVideo(event) {
      this.showVideo = event.target.checked
      if (!this.showVideo) {
        this.destroyPlayer()
      } else {
        this.loadVideos()
      }
      setStore('procee_initVideo', this.showVideo)
    },
    destroyPlayer() {
      //销毁播放器
      if (!this.$refs.playerArr) {
        return
      }
      this.$refs.playerArr.forEach(player => player.destroy())
    },
    loadVideos() {
      this.destroyPlayer()

      if (this.showVideo) {
        const params = {
          processId: this.activeKey,
          page: 1,
          limit: 1000
        }
        getAction(this.url.getVideoList, params).then(res => {
          if (res.success) {
            this.videoList = res.result.records
          }
        })
      }
    },
    loadPoints() {
      const params = {
        devProcessId: this.activeKey,
        isProImportant: 1,
        page: 1,
        pageSize: 500,
        column: 'devProcessSort',
        order: 'asc'
      }
      getAction(this.url.getProceePoints, params).then(res => {
        if (res.success) {
          this.pointsList = res.result.records
          this.loadPointsData()
        }
      })
      this.getModelData()
    },
    setFastRange(val) {
      this.timeRange.splice(0, 2, val[0], val[1])
      this.loadPointsData()
      this.getModelData()
    },
    loadPointsData() {
      const [startTime, endTime] = this.timeRange
      const diffSeconds = moment(endTime).diff(moment(startTime), 'second')
      let interval = Math.floor(diffSeconds / 2000)
      interval = Math.max(1, interval)
      // 取出pointsList元素的pointCode属性，拼接成字符串，用逗号隔开
      const points = this.pointsList.map(point => point.pointCode).join(',')
      const parms = {
        startTime: startTime.length < 19 ? startTime + ':00' : startTime,
        endTime: endTime.length < 19 ? endTime + ':00' : endTime,
        points: points,
        interval
      }
      getAction(this.url.getPointData, parms).then(res => {
        if (res.success) {
          res.result.forEach(info => {
            const series = []
            series.push({
              name: info.pointName,
              data: this.objectArrTo2Array(info.details),
              type: 'line',
              smooth: true,
              showSymbol: false
            })

            this.$set(this.pointsLineOpts, info.pointCode, {
              tooltip: {
                trigger: 'axis',
                formatter: function(params) {
                  let relVal = moment(params[0].value[0]).format('YYYY-MM-DD HH:mm')
                  for (let i = 0, l = params.length; i < l; i++) {
                    relVal +=
                      '<br/>' +
                      params[i].marker +
                      params[i].seriesName +
                      ' : ' +
                      (params[i].value[1] === null ? '' : Number(params[i].value[1]).toFixed(2))
                  }
                  return relVal
                }
              },
              grid: {
                top: 30,
                left: 30,
                right: 30,
                bottom: 30
              },
              xAxis: {
                type: 'time'
              },
              yAxis: [
                {
                  name: info.unit,
                  type: 'value'
                }
              ],
              series: series
            })
          })
        }
      })
    },
    getModelData() {
      const [startTime, endTime] = this.timeRange
      const parms = {
        startTime: startTime.length < 19 ? startTime + ':00' : startTime,
        endTime: endTime.length < 19 ? endTime + ':00' : endTime,
        devProcessId: this.activeKey
      }
      getAction(this.url.getModelData, parms).then(res => {
        if (res.success) {
          this.displayGroups = res.result

          for (const name in res.result) {
            if (Object.hasOwnProperty.call(res.result, name)) {
              const ponits = res.result[name]

              const series = []
              const legend = []
              ponits.forEach(point => {
                legend.push(point.pointName)
                series.push({
                  name: point.pointName,
                  data: this.objectArrTo2Array(point?.timeSeriesInfo?.details),
                  type: 'line',
                  smooth: true,
                  showSymbol: false
                })
              })

              this.$set(this.groupLineOpts, name, {
                tooltip: {
                  trigger: 'axis',
                  formatter: function(params) {
                    let relVal = moment(params[0].value[0]).format('YYYY-MM-DD HH:mm')
                    for (let i = 0, l = params.length; i < l; i++) {
                      relVal +=
                        '<br/>' +
                        params[i].marker +
                        params[i].seriesName +
                        ' : ' +
                        (params[i].value[1] === null ? '' : Number(params[i].value[1]).toFixed(2))
                    }
                    return relVal
                  }
                },
                legend: {
                  data: legend
                },
                grid: {
                  top: 30,
                  left: 30,
                  right: 30,
                  bottom: 30
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: series
              })
            }
          }
        }
      })
    },
    getProcess() {
      const parms = {
        column: 'sort',
        order: 'asc',
        isDisplay: '1',
        pageNo: 1,
        pageSize: 1000
      }
      getAction(this.url.getProcesslist, parms).then(res => {
        if (res.success) {
          this.processList = res.result.records
          this.activeKey = res.result.records[0].id
          this.switchProcess()
        }
      })
    },
    switchProcess(v) {
      if (v) {
        this.activeKey = v
      }
      this.process = this.processList.find(p => p.id === this.activeKey)
      this.loadVideos()
      this.loadPoints()
    },
    changeRowChartCnt() {
      //所有echart对象重新加载
      this.$nextTick(() => {
        this.$refs.echart.forEach(ec => {
          ec.chart.resize()
        })
      })
    },
    toOtherPage(route) {
      this.$router.push({
        path: route
      })
    },
    to3Dpage(id) {
      const permissionList = this.$store.getters.permissionList
      const _3dpath = getIframesMenuPathBykeyWord(permissionList, 'page=3d')

      getAction(this.url.getWebViewPanel, { bizType: 'process', bizId: id }).then(res => {
        if (res.success && res.result) {
          const viewData = res.result.viewData
          const panels = res.result.panels

          const _3diframes = getIframesByUrl('page=3d')
          if (_3diframes.length) {
            const contentWindow = _3diframes[0].contentWindow
            contentWindow.postMessage(
              JSON.stringify({
                event: 'setView',
                params: JSON.parse(viewData)
              }),
              '*'
            )
            const panelDataArr = []
            panels &&
              panels.forEach(panel => {
                panelDataArr.push({
                  name: panel.panelName,
                  code: panel.panelCode,
                  position: typeof panel.position == 'string' ? JSON.parse(panel.position) : panel.position,
                  list: panel.list
                })
              })
            contentWindow.postMessage(
              JSON.stringify({
                event: 'showPopup',
                params: panelDataArr
              }),
              '*'
            )
            this.$router.push({ path: _3dpath })
          } else {
            this.$message.warning('请先打开三维页面加载模型')
          }
        } else {
          this.$message.warning('未配置相关视角，请联系管理员')
        }
      })
    },
    objectArrTo2Array(arrs) {
      const res = []
      arrs.forEach(arr => {
        const item = [arr.timeStamp, arr.value]
        res.push(item)
      })
      return res
    },
    /* 图片预览 */
    getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','))
      }
      return getFileAccessHttpUrl(text)
    },
    clear(idx) {
      let dataStr = window.localStorage.getItem('playData') || '[]'
      let data = JSON.parse(dataStr)
      data[idx - 1] = null
      window.localStorage.setItem('playData', JSON.stringify(data))
    }
  },
  destroy(idx) {
    this.clear(idx.substring(idx.length - 1))
  }
}
</script>
<style lang="less" scoped>
.b-active {
  color: @primary-color;
  transform: scale(1.05);
}
.fixed-toolbox {
  position: fixed;
  top: 250px;
  right: -10px;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
  padding: 10px;
  z-index: 999;
  cursor: pointer;
  border-radius: 5px;
  font-size: 20px;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
}

.flex-item {
  flex-basis: auto; /* 每个项的基础宽度自动适应内容 */
  margin: 4px 6px;
  padding: 6px;
  border: 0;
  cursor: pointer;
}
</style>
